export default __webpack_public_path__ + "images/38_1_image.jpg";